export default {"src":"/_next/static/media/icone-potential.0ab42c65.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};